(function ($,Glide,Tooltip) {
'use strict';

$ = $ && $.hasOwnProperty('default') ? $['default'] : $;
Glide = Glide && Glide.hasOwnProperty('default') ? Glide['default'] : Glide;
Tooltip = Tooltip && Tooltip.hasOwnProperty('default') ? Tooltip['default'] : Tooltip;

$('[data-ekawarnakimia-glide]').each(function() {
    let glide = new Glide(this, $(this).data('ekawarnakimia-glide'));

    glide.on('build.after', function() {
        let $container  = $(glide.selector);
        let $slides     = $container.find('.glide__slides');

        if ($slides.children().length <= glide.settings.perView) {
            glide.disable();
            $container.addClass('disabled');
        } else {
            glide.enable();
            $container.removeClass('disabled');
        }
    });

    glide.mount();
});

document.querySelectorAll('[data-toggle="tooltip"]').forEach(el => new Tooltip(el, {
    title: el.dataset.title
}));

}(jQuery,Glide,Tooltip));
